export default [
  {
    path: "/eDCBNI/mobile",
    component: () => import("@/pages/mobile"),
    meta: {
      title: "互联网申报",
      type: "mobile"
    },
    children: [
      {
        path: "/mobile/",
        redirect: "/eDCBNI/mobile/Declaration"
      },
      {
        path: "/eDCBNI/mobile/Declaration",
        name: "mobileInternetDeclaration",
        component: () => import("@/pages/mobile/InternetDeclaration.vue"),
        meta: {
          title: "互联网申报",
          type: "mobile"
        }
      },
      {
        path: "/eDCBNI/mobile/List",
        name: "mobileInternetList",
        component: () => import("@/pages/mobile/InternetList.vue"),
        meta: {
          title: "互联网申报",
          type: "mobile"
        }
      }
    ]
  }
];